"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var segmentedButtons_module_scss_1 = __importDefault(require("@cdo/apps/componentLibrary/segmentedButtons/segmentedButtons.module.scss"));
var fontAwesomeV6Icon_1 = __importDefault(require("@cdo/apps/componentLibrary/fontAwesomeV6Icon"));
var SegmentedButton = function (_a) {
    var label = _a.label, disabled = _a.disabled, selected = _a.selected, _b = _a.buttonType, buttonType = _b === void 0 ? 'withLabel' : _b, iconLeft = _a.iconLeft, iconRight = _a.iconRight, icon = _a.icon, value = _a.value, onChange = _a.onChange;
    var handleClick = (0, react_1.useCallback)(function () { return onChange(value); }, [onChange, value]);
    return (react_1.default.createElement("button", { type: "button", disabled: disabled, onClick: handleClick, className: (0, classnames_1.default)(segmentedButtons_module_scss_1.default.segmentedButton, segmentedButtons_module_scss_1.default["segmentedButton-".concat(buttonType)], selected && segmentedButtons_module_scss_1.default.selectedSegmentedButton) },
        buttonType === 'iconOnly' && icon && (react_1.default.createElement(fontAwesomeV6Icon_1.default, { iconName: icon.iconName, iconStyle: icon.iconStyle, title: icon.title })),
        buttonType === 'withLabel' && iconLeft && (react_1.default.createElement(fontAwesomeV6Icon_1.default, { iconName: iconLeft.iconName, iconStyle: iconLeft.iconStyle, title: iconLeft.title })),
        label && react_1.default.createElement("span", null, label),
        buttonType === 'withLabel' && iconRight && (react_1.default.createElement(fontAwesomeV6Icon_1.default, { iconName: iconRight.iconName, iconStyle: iconRight.iconStyle, title: iconRight.title }))));
};
exports.default = SegmentedButton;
